import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.jolie = bracketIndenting()
